import { FC, ReactElement } from 'react';

import { Icon } from '../../../components';
import { Direction } from '../../../entities/@navigation/NavigationControls/NavigationControls';
import { WayfindingType } from '../../../entities/@navigation/Wayfinding/Wayfinding';
import { useTrans } from '../../../hooks';
import { Button, ButtonProps, WayfindingWrapper } from '../..';

import './WayfindingDirectionButton.scss';

interface WayfindingDirectionButtonProps extends ButtonProps {
    id: string;
    direction: Direction;
    className?: string;
}

export const WayfindingDirectionButton: FC<WayfindingDirectionButtonProps> = ({
    id,
    text,
    direction,
    disabled,
    className = '',
    ...buttonProps
}): ReactElement => {
    const trans = useTrans();

    const type = direction === Direction.prev
        ? WayfindingType.left
        : WayfindingType.right;

    const label = direction === Direction.prev
        ? trans('common.prev')
        : trans('common.next');

    const icon = direction === Direction.prev
        ? 'wayfinding-left'
        : 'wayfinding-right';

    return (
        <WayfindingWrapper
            isDisabled={disabled}
            id={`${id}-${direction}`}
            type={type}
            label={label}
            className={`wayfinding-direction-button ${className}`}
            iconPathClassName="wayfinding-direction-button__icon-path"
        >
            <Button
                {...buttonProps}
                text={text}
                disabled={disabled}
                className="wayfinding-direction-button__button"
                labelClassName="wayfinding-direction-button__button-label"
            >
                <Icon
                    name={icon}
                    className="wayfinding-direction-button__icon"
                    pathClassName="wayfinding-direction-button__icon-path"
                />
            </Button>
        </WayfindingWrapper>
    );
};
